import { z } from 'zod';
import { AftermarketProductCategory, MarkupType } from '@trnsact/trnsact-shared-types';

export const createCustomProductSchema = z.object({
  cost: z.number().min(0),
  retailPrice: z.number().min(0),
  description: z.string().max(300).trim(),
  name: z.string().min(3, { message: 'Product Name required' }).max(100).trim(),
  type: z.object(
    { label: z.string(), value: z.nativeEnum(AftermarketProductCategory) },
    { message: 'Product Type required' }
  ),
  vendor: z.object({ label: z.string(), value: z.string() }, { message: 'Field required' }),
  markup: z.object({ value: z.number().min(0), type: z.nativeEnum(MarkupType) }),
});
